import axios, { AxiosInstance, AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { toast } from '../hooks/use-toast';
import { getOktaToken, redirectToLogin } from './okta/oktaConfig';

// Istanza axios con configurazione base
const axiosInstance: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 secondi
});

// Interceptor per le richieste
axiosInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    // Aggiungi token di autenticazione da Okta, se disponibile
    const token = await getOktaToken();
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Interceptor per risposte
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    const response = error.response as AxiosResponse<{ message?: string }>;
    
    if (response) {
      // Gestisci errori per status code
      switch (response.status) {
        case 401: // Non autorizzato
          // Reindirizza alla pagina di login (ricordando la pagina corrente)
          redirectToLogin();
          toast({
            title: 'Sessione scaduta',
            description: 'Effettua nuovamente il login',
            status: 'error',
          });
          break;
          
        case 403: // Accesso negato
          toast({
            title: 'Accesso negato',
            description: 'Non hai i permessi necessari',
            status: 'error',
          });
          break;
          
        case 404: // Risorsa non trovata
          toast({
            title: 'Risorsa non trovata',
            description: 'La risorsa richiesta non esiste',
            status: 'error',
          });
          break;
          
        case 500: // Errore server
          toast({
            title: 'Errore del server',
            description: 'Si è verificato un errore nel server',
            status: 'error',
          });
          break;
          
        default:
          toast({
            title: 'Errore',
            description: response.data?.message || 'Si è verificato un errore imprevisto',
            status: 'error',
          });
      }
    } else {
      // Errore di rete o timeout
      toast({
        title: 'Errore di connessione',
        description: 'Impossibile connettersi al server',
        status: 'error',
      });
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;